import { onlineManager, useSuspenseQuery } from '@tanstack/react-query'
import { Outlet, createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import type { GetRefundedResponse } from '@/types/refunded'
import BookingDetail from '@/components/my-booking/booking-detail'
import { queryKeys } from '@/queries/keys'
import { getBookingQueryOptions } from '@/queries/query'
import { getRefundedQueryOptions } from '@/queries/query/refunded'

export const Route = createFileRoute('/my-booking/refund/$id')({
  params: {
    parse: (params) => ({
      id: z.string().trim().parse(params.id),
    }),
    stringify: ({ id }) => ({ id }),
  },
  loader: async ({ context, params }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      const refundQuery = context.queryClient.ensureQueryData(
        getRefundedQueryOptions(params.id),
      )
      const { data } = await refundQuery
      const bookingQuery = context.queryClient.ensureQueryData(
        getBookingQueryOptions(data.refund.adhoc_booking.id),
      )
      return [refundQuery, bookingQuery]
    }
    const refundBooking = context.queryClient.getQueryData<GetRefundedResponse>(
      queryKeys.refunded.detail(params.id),
    )
    return [
      refundBooking,
      ...(refundBooking?.data?.refund?.adhoc_booking?.id
        ? [
            context.queryClient.getQueryData(
              queryKeys.booking.detail(
                refundBooking.data.refund.adhoc_booking.id,
              ),
            ),
          ]
        : []),
    ]
  },
  component: RouteComponent,
})

function RouteComponent() {
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })

  const {
    data: { data: bookingData },
  } = useSuspenseQuery(getRefundedQueryOptions(bookingId))

  return (
    <>
      <BookingDetail parentTitle="My Booking" booking={bookingData.refund} />
      <Outlet />
    </>
  )
}
